import { useCreateProration } from 'hooks/prorations/mutations';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { OrderProperty } from 'types/order';
import useAlert from 'utils/alert';
import { CreateProrationForm } from './types';

type Params = {
  selectedProperty: OrderProperty;
  onClose: () => void;
  onCreated?: (proratedId: string) => void;
};

export const useCreateProrationModal = ({ selectedProperty, onClose, onCreated }: Params) => {
  const { id: orderId } = useParams<{ id: string }>();
  const queryClient = useQueryClient();
  const showAlert = useAlert();
  const prorationForm = useForm<CreateProrationForm>({
    defaultValues: {
      estateId: selectedProperty._id,
      description: '',
      kind: 'installment',
      type: 'basic',
    },
  });

  const { mutate: createProrationMutation, isLoading } = useCreateProration({
    queryConfig: {
      onSuccess: (response, variables) => {
        const newProration = [...response.createOrderProration.prorations]
          .reverse()
          .find((proration) => (
            proration.estate._id === variables.estateId
            && proration.description === variables.description
          ));
        showAlert('Proration created successfully', 'success');
        queryClient.invalidateQueries([{ orderId }, 'prorations']);
        if (onCreated && newProration) {
          onCreated(newProration._id);
        }
        onClose();
      },
    },
  });

  const onConfirm = prorationForm.handleSubmit((data) => {
    if (!data.description.trim() || !data.kind || !data.type) {
      return;
    }

    createProrationMutation({
      orderId,
      ...data,
    });
  });

  return {
    isLoading,
    prorationForm,
    onConfirm,
  };
};
